module.exports = __webpack_public_path__ + "assets/img/success.9e2651f2.svg";